export default __webpack_public_path__ + "images/Z4.fb8bf0e.png";